var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import { useClickOutside } from "ftl-core";
import { default as FTLDropdownMenu, } from "./FTLDropdownMenu";
import { makeStyles } from "@material-ui/core";
export const useStyles = makeStyles({
    button: {
        display: "inline-block",
        background: "none",
        color: "inherit",
        border: "none",
        padding: 0,
        font: "inherit",
        cursor: "pointer",
        outline: "inherit",
    },
});
export default (_a) => {
    var { open = false, children, controller, onOpen, onClose, disabled, hideOnMenuClick } = _a, otherProps = __rest(_a, ["open", "children", "controller", "onOpen", "onClose", "disabled", "hideOnMenuClick"]);
    const anchorRef = useRef(null);
    const popperRef = useRef(null);
    const classes = useStyles();
    useClickOutside([popperRef, anchorRef], (e) => {
        open && onClose(e);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: classes.button, ref: anchorRef, onClick: (e) => {
                if (open)
                    onClose(e);
                else
                    onOpen(e);
            } }, controller),
        React.createElement(FTLDropdownMenu, Object.assign({ ref: popperRef, open: open, anchorEl: anchorRef.current, onClose: onClose }, otherProps, { onClick: (e) => {
                hideOnMenuClick && onClose(e);
            } }), children)));
};
//# sourceMappingURL=FTLDropdownMenuWithController.js.map